import useMediaQuery, { mediaQueryPoints } from '@/hooks/useMediaQuery';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Space, Upload } from 'antd';
import React from 'react';

function FormUpload({ mutation, onChange, value, ...props }) {
  const handleChange = (info) => {
    const { fileList } = info;

    const updatedFileList = fileList.map((file) => {
      if (file.originFileObj && !file.url && !file.thumbUrl) {
        const objectUrl = URL.createObjectURL(file.originFileObj);
        return {
          ...file,
          url: objectUrl,
          thumbUrl: objectUrl,
        };
      }

      if (file.status === 'done' && file.response?.url) {
        return {
          ...file,
          url: file.response.url,
          thumbUrl: file.thumbUrl || URL.createObjectURL(file.originFileObj),
        };
      }

      return file;
    });

    // Call the parent onChange with updated file list
    onChange?.({ ...info, fileList: updatedFileList });
  };

  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoints.md}px)`);

  return (
    <Upload
      accept="image/jpeg,image/png,image/jpg"
      maxCount={1}
      listType="picture"
      beforeUpload={() => false} // Prevent auto upload by default
      fileList={value || []}
      onChange={handleChange}
      showUploadList={{
        showPreviewIcon: true,
        showRemoveIcon: true,
        showDownloadIcon: false,
      }}
      {...props}
    >
      <Space className="w-full">
        <p className="text-sm italic text-gray-400 max-md:text-xs">
          Only accept formats image/jpeg, image/png, image/jpg
        </p>
        <Button icon={<PlusOutlined />} type="link" className="max-md:text-xs">
          {isMobile ? null : 'Image'}
        </Button>
      </Space>
    </Upload>
  );
}

export default FormUpload;
